import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedCheckboxRHF,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";

import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";

interface IWebROESubmissionHeader {
	acountingProfessionalDDLItems:any,
	companyDDLItems: any,
	onAccountantsSelectionChangeHandler: (value: any) => void,
	// onApplyButtonClickedHandler: (value: any) => void,
	onClientsSelectionChangeHandler: (value: any) => void,
	setStateRunGetListAPICall: (value: boolean) => void
}

export const WebROESubmissionHeader: React.FC<
	IWebROESubmissionHeader
> = ({ acountingProfessionalDDLItems, companyDDLItems, setStateRunGetListAPICall, onAccountantsSelectionChangeHandler,onClientsSelectionChangeHandler ,
	// onApplyButtonClickedHandler
 }) => {

	return (
		<>
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					background: "#fff",
					border: "1px solid #e5e7eb",
					borderBottom: 0,
					borderRadius: "2px 2px 0 0",
					padding: "31px 20px 1rem 20px",
					marginBottom: "0px!important",
				}} columnSpacing={2}>
				<Grid
					size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}

					sx={{
						color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem",
						"& .MuiGrid-root": {

						},

					}}>
					<EnhancedDropDownRHFWithLabel
						selectName={"accountingProfessional"}
						items={acountingProfessionalDDLItems ?? []}
						selectedItem={"all"}
						label={"Accounting Professional"}
						testId={"accounting-professional-ddl"}
						onSelectionChangeHandler={onAccountantsSelectionChangeHandler}
					/>
					<EnhancedDropDownRHFWithLabel
						selectName={"showEmployees"}
						items={[

							{
								label: "ROE Created",
								value: 300,
							},
							{
								label: "File Generated",
								value: 100,
							},
							{
								label: "File Processed",
								value: 200,
							},
						]}
						label={"Show Employees"}
						testId={"show-employees"}
						selectedItem={300}
					// onSelectionChangeHandler={onEarningTypeSelectionChangeHandler}
					/>
					<EnhancedButtonPrimeReact
						label="Apply Filter"
						raised
						type="submit"
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
						// onClickHandler={onApplyButtonClickedHandler}
					/>
				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
					sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem" }}
				>
					<EnhancedDropDownRHFWithLabel
						selectName={"company"}
						items={companyDDLItems ?? []}

						label={"Company"}
						testId={"company-ddl"}
						selectedItem={"all"}
						onSelectionChangeHandler={onClientsSelectionChangeHandler}
					/>
					<EnhancedDropDownRHFWithLabel
						selectName={"accountType"}
						items={[
							// {
							// 	label: "All",
							// 	value: "all",
							// },
							{
								label: "Live",
								value: 100,
							},
							{
								label: "Test",
								value: 200,
							},
						]}
						label={"Account Type"}
						testId={"account-type"}
						selectedItem={100}

					/>

				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
				
				sx={{
					marginTop:"10px"
				}}>
					<EnhancedCheckboxRHF
						name="showArchive"
						checked={false}
						testId="show-archive"
						checkboxLabel="Show Archive"
					/>
				</Grid>

			</Grid>
		</>
	);
};

